import { Select } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${props => props.theme.colors.primary};


  .tablePedidos:not(td) {
    background-color: #e6f7ff !important;
  }
`;
export const StepsStyle = styled.div`
  .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    background: #389e0d;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #f0f0f0;
  }
`;
export const TitleLabel = styled.div`
  padding-bottom: 10px;
`;

export const SelectControl = styled(Select)`
  @media (min-width: 600px) {
    width: 350px;
  }
  width: 100%;
`;

export const TranspIcon = styled.span`
  position: absolute;
`;

export const ModalTransp = styled.div`
  margin: 4% 0% 0% 0%;
  width: 95%;
`;